// extracted by mini-css-extract-plugin
module.exports = {"downloadApp":"download-app-module--downloadApp--3Eqnn","button":"download-app-module--button--2hciq"};